export default "__VITE_ASSET__wRhrAv8x__"